import React, { FC } from "react";
import { Dropdown, Menu, Button, Space } from "antd";
import { LANG_MAP, changeLang, Lang } from "@/locales";
import { useTranslation } from "react-i18next";

export const ToggleLang: FC = () => {
  const onClick = ({ key }: any) => {
    changeLang(key);
  };
  const { i18n } = useTranslation();
  console.log(i18n.language);

  return (
    <Dropdown
      overlay={
        <Menu onClick={onClick}>
          {LANG_MAP.map((item) => (
            <Menu.Item key={item.value}>{item.label}</Menu.Item>
          ))}
        </Menu>
      }
    >
      <Button
        style={{
          alignSelf: "center",
          color: "#999",
          marginTop: 24,
        }}
        type="text"
      >
        <Space size={6}>
          <i className="authing-icon authing-login-language"></i>
          {LANG_MAP.find((item) => item.value === (i18n.language || Lang.zhCn))?.label}
        </Space>
      </Button>
    </Dropdown>
  );
};
